/**
 * DDD Domain Dependency Injection Symbols
 * 
 * Centralized symbols for dependency injection to avoid circular dependencies.
 * Extracted from DDDContainerModule to break circular import chains.
 */

export const DDD_SYMBOLS = {
  // Application Services
  DomainApplicationService: Symbol.for('DomainApplicationService'),
  BoundedContextApplicationService: Symbol.for('BoundedContextApplicationService'),
  AggregateApplicationService: Symbol.for('AggregateApplicationService'),
  ProjectApplicationService: Symbol.for('ProjectApplicationService'),
  PackageMappingApplicationService: Symbol.for('PackageMappingApplicationService'),
  
  // Query Services
  DomainCQRSQueryService: Symbol.for('DomainCQRSQueryService'),
  BoundedContextQueryService: Symbol.for('BoundedContextQueryService'),
  AggregateQueryService: Symbol.for('AggregateQueryService'),
  ProjectQueryService: Symbol.for('ProjectQueryService'),
  
  // Command Services
  DomainCommandService: Symbol.for('DomainCommandService'),
  BoundedContextCommandService: Symbol.for('BoundedContextCommandService'),
  AggregateCommandService: Symbol.for('AggregateCommandService'),
  ProjectCommandService: Symbol.for('ProjectCommandService'),
  
  // Repositories
  IDomainRepository: Symbol.for('IDomainRepository'),
  IBoundedContextRepository: Symbol.for('IBoundedContextRepository'),
  IAggregateRepository: Symbol.for('IAggregateRepository'),
  IProjectRepository: Symbol.for('IProjectRepository'),
  IPackageMappingRepository: Symbol.for('IPackageMappingRepository'),
  
  // Command Handlers
  CreateDomainHandler: Symbol.for('CreateDomainHandler'),
  UpdateDomainHandler: Symbol.for('UpdateDomainHandler'),
  GetDomainHandler: Symbol.for('GetDomainHandler'),
  ListDomainsHandler: Symbol.for('ListDomainsHandler'),
  CreateBoundedContextHandler: Symbol.for('CreateBoundedContextHandler'),
  UpdateBoundedContextHandler: Symbol.for('UpdateBoundedContextHandler'),
  GetBoundedContextHandler: Symbol.for('GetBoundedContextHandler'),
  ListBoundedContextsHandler: Symbol.for('ListBoundedContextsHandler'),
  CreateAggregateHandler: Symbol.for('CreateAggregateHandler'),
  UpdateAggregateHandler: Symbol.for('UpdateAggregateHandler'),
  GetAggregateHandler: Symbol.for('GetAggregateHandler'),
  CreateProjectHandler: Symbol.for('CreateProjectHandler'),
  UpdateProjectHandler: Symbol.for('UpdateProjectHandler'),
  GetProjectHandler: Symbol.for('GetProjectHandler'),
  ListProjectsHandler: Symbol.for('ListProjectsHandler'),
  
  // Infrastructure
  IEventBus: Symbol.for('IEventBus'),
  ICommandBus: Symbol.for('ICommandBus'),
  IQueryBus: Symbol.for('IQueryBus'),
  
  // Domain Services
  IDomainAnalysisService: Symbol.for('IDomainAnalysisService'),
  IBoundedContextAnalysisService: Symbol.for('IBoundedContextAnalysisService'),
  
  // AI Integration
  AIAnalysisService: Symbol.for('AIAnalysisService'),
  PersonLookupPort: Symbol.for('PersonLookupPort'),
  
  // Value Objects and Factories
  DomainIdFactory: Symbol.for('DomainIdFactory'),
  BoundedContextIdFactory: Symbol.for('BoundedContextIdFactory'),
  AggregateIdFactory: Symbol.for('AggregateIdFactory'),
  
  // Controllers
  DomainController: Symbol.for('DomainController'),
  BoundedContextController: Symbol.for('BoundedContextController'),
  AggregateController: Symbol.for('AggregateController'),
  ProjectController: Symbol.for('ProjectController'),
  PackageMappingController: Symbol.for('PackageMappingController'),
  
  // Database Port
  DatabasePort: Symbol.for('DatabasePort'),
} as const;